import React, { useState } from "react";
import { useActivePath } from "../../shared/ActivePathContext";
import NavItem from "../../shared/navItem/NavItem";
import { NavMenuContainer, NavMenuDropdown } from "./NavMenuStyles";
const NavMenu = ({ verticalNavWidth, customLinkComponent, ...rest }) => {
    const { to, subLinks = [] } = rest;
    const { isActivePath } = useActivePath();
    const subTos = subLinks.filter((sl) => !!sl.to).map((sl) => sl.to);
    if (!!to?.length) {
        subTos.push(to);
    }
    const [menuOpen, setMenuOpen] = useState(false);
    const openMenu = () => {
        setMenuOpen(true);
    };
    const closeMenu = () => {
        setMenuOpen(false);
    };
    return (React.createElement(NavMenuContainer, { onMouseOver: openMenu, onMouseLeave: closeMenu },
        React.createElement(NavItem, { ...rest, active: isActivePath(rest), isVertical: true, customLinkComponent: customLinkComponent }),
        menuOpen && (React.createElement(NavMenuDropdown, { width: verticalNavWidth }, subLinks
            .filter((subLink) => subLink.visible !== false)
            .map((subLink) => (React.createElement(NavItem, { ...subLink, active: isActivePath(subLink), key: subLink.name, customLinkComponent: customLinkComponent, isVertical: true })))))));
};
export default NavMenu;
//# sourceMappingURL=NavMenu.js.map